// extracted by mini-css-extract-plugin
export default {"container":"Error_container__Xn5G7","status":"Error_status__FF8e5"};